import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  private readonly http = inject(HttpClient);

  private readonly apiUrl = 'https://api.ipify.org?format=json';

  getPublicIp(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>(this.apiUrl);
  }
}
